$(function () {
	if ($(window).width() <= 1279) {
		$('.js-peculiarities-item').click(function () {
			$(this).toggleClass('peculiarities__item-heading_active').next().slideToggle();
		});
	}
})